function formatPrice(priceInput) {
  return (priceInput / 100).toFixed(2).replace('.', ',') + '€ EUR';
}

class ProductConfig extends HTMLElement {
  constructor() {
    super();
    this.allOptions = this.querySelectorAll('.product-config-tub');
    this.allInputs = this.querySelectorAll(".product-config-value-item");
    this.productJsonData = JSON.parse(document.getElementById("product-configurator-json-data").textContent);

    document.querySelector('.configurator-price');

    this.allOptions[0].setAttribute('data-active', 'true');

    this.removeDuplicate();

    this.registerListeners();

    this.update();
  }

  registerListeners() {
    this.allOptions.forEach(option => {
      option.addEventListener("click", () => {
        //this.querySelector(".product-config-tub[data-active='true']").setAttribute("data-active", false);
        //option.setAttribute("data-active", true);
      })
    });

    this.allInputs.forEach(input => {
      input.addEventListener("click", () => {
        input.parentElement.querySelector("[data-active='true']")?.setAttribute("data-active", false);
        input.setAttribute("data-active", true);

        this.update();
      })
    })
  }

  update() {
    const currentSelectedVariants = this.getCurrentSelectedVariants();
    const currentSelectedVariantIds = currentSelectedVariants.map(variant => variant.id);

    const containsSchirm = currentSelectedVariants.some(variant => variant.name.toLowerCase().includes("schirm"));

    if(containsSchirm) {
      document.querySelector("vuv-configurator-image").classList.remove("transform-images-no-upsell");
    } else {
      document.querySelector("vuv-configurator-image").classList.add("transform-images-no-upsell");
    }

    document.querySelectorAll(".vuv-configurator-image-container").forEach(container => {
      const matchingVariantId = parseInt(container.dataset.variantId);
      container.setAttribute("data-show", currentSelectedVariantIds.includes(matchingVariantId));
    });


    let totalPrice = 0;
    currentSelectedVariants.forEach(variant => totalPrice += variant.price);
    document.querySelector(".configurator-price").textContent = formatPrice(totalPrice);
    


  }

  isUpsellSelected() {

  }

  getCurrentSelectedVariants() {
    const currentSelectedVariants = [];

    const uniqueProductIds = []
    this.allInputs.forEach(input => {
      const inputProductId = parseInt(input.dataset.productId);
      if(!uniqueProductIds.includes(inputProductId)) {
        uniqueProductIds.push(inputProductId);
      }
    });

    uniqueProductIds.forEach(productId => {
      const currentSelectedOptionTitles = []

      const allActiveInputsForProduct = Array.from(this.allInputs).filter(input => parseInt(input.dataset.productId) == productId).filter(input => input.dataset.active === "true");
      allActiveInputsForProduct.forEach(input => {
        currentSelectedOptionTitles.push(input.dataset.option);
      });

      this.productJsonData[productId].forEach(productVariant => {
        let includesTitle = true;

        currentSelectedOptionTitles.forEach(optionTitle => {
          if(!productVariant.title.includes(optionTitle)) {
            includesTitle = false;
          }
        });

        if(!includesTitle) { return };

        currentSelectedVariants.push(productVariant);
      });

    });

    return currentSelectedVariants;
  }

  removeDuplicate() {
    this.allOptions.forEach((tub) => {
      const tubsValues = [
        ...tub.querySelectorAll('.product-config-value-item'),
      ];
      const texts = new Set(
        tubsValues.map((e) => e.getAttribute('data-option'))
      );

      tubsValues.forEach((val) => {
        if (texts.has(val.getAttribute('data-option'))) {
          texts.delete(val.getAttribute('data-option'));
        } else {
          val.remove();
        }
      });
    });
  }
}

customElements.define('product-config', ProductConfig);
